import { AbstractControl, ValidationErrors } from '@angular/forms';

export function dateRangeValidator(control: AbstractControl): ValidationErrors | null {
	const dateFrom = control.get('dateFrom')?.value as Date | string | null;
	const dateTo = control.get('dateTo')?.value as Date | string | null;

	if (!dateFrom || !dateTo) {
		return null;
	}

	const from = dateFrom instanceof Date ? dateFrom : new Date(dateFrom);
	const to = dateTo instanceof Date ? dateTo : new Date(dateTo);

	if (to < from) {
		return { dateRange: true };
	}

	return null;
}
